import { z } from 'zod';
import { SUPPORTED_UNITS_SCHEMA } from '../../quote-unit/unit-types.ts';
import { PRODUCT_TYPE_SCHEMA } from '../../product-type/product-types.ts';

export const MATERIAL_SUPPORTED_UNITS_SCHEMA = SUPPORTED_UNITS_SCHEMA.extract([
    'KILOGRAM',
    'TON',
    'CUBIC_METER',
    'LITER',
    'PIECE',
    // NOTE: adding transport unit here enables business case where material is delivered and invoiced solely on the number of truck deliveries and not on specific required quantity.
    'TRANSPORT',
]);

export type MATERIAL_SUPPORTED_UNITS = z.infer<typeof MATERIAL_SUPPORTED_UNITS_SCHEMA>;

export const MATERIAL_PRODUCT_CATEGORY_SCHEMA = z.enum(['MATERIAL', 'MATERIAL_SERVICE']);

export const MATERIAL_PRODUCT_TYPES_SCHEMA = PRODUCT_TYPE_SCHEMA.extract([
    'BULK_MATERIAL',
    'RECYCLED_BULK_MATERIAL',
    'NON_HAZARDOUS_WASTE_DISPOSAL',
    'HAZARDOUS_WASTE_DISPOSAL',
    'NON_HAZARDOUS_WASTE_RECYCLING',
    'HAZARDOUS_WASTE_RECYCLING',
]);

export type MATERIAL_PRODUCT_TYPES = z.infer<typeof MATERIAL_PRODUCT_TYPES_SCHEMA>;

export const BulkMaterialProductTypes = MATERIAL_PRODUCT_TYPES_SCHEMA.extract(['BULK_MATERIAL']);

export const WasteProductTypes = MATERIAL_PRODUCT_TYPES_SCHEMA.extract([
    'NON_HAZARDOUS_WASTE_DISPOSAL',
    'NON_HAZARDOUS_WASTE_RECYCLING',
]);

export const DangerousWasteProductTypes = MATERIAL_PRODUCT_TYPES_SCHEMA.extract([
    'HAZARDOUS_WASTE_DISPOSAL',
    'HAZARDOUS_WASTE_RECYCLING',
]);

export const MATERIAL_QUOTE_STATUS_SCHEMA = z.enum(['DRAFT', 'ORDERED']);
